import axios from 'axios';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { ConfigContext } from '../../Context/ConfigContext';
import { Toast } from 'primereact/toast';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { NavLink, useNavigate } from 'react-router-dom';
import { Tag } from 'primereact/tag';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { generateBarcode } from '../../Components/Options';
import StoreSelect from '../../Components/Store';

const ProductList = () => {
    const { apiUrl, apiHeadersJson, store_id } = useContext(ConfigContext);
    const headers = apiHeadersJson;
    const [rows, setRows] = useState([]);
    const [getLoadingrows, setgetLoading] = useState(true);
    const toast = useRef(null);
    const [showConfirmDialog, setShowConfirmDialog] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [keyword, setKeyword] = useState('');

    const GetList = async () => {
        try {
            setgetLoading(true);
            const response = await axios.get(`${apiUrl}/Masters/GetProductList`, { params: { keyword, store_id: store_id }, headers });
            const { success, data, message } = response.data;
            if (success) {
                setRows(data);
                setgetLoading(false);
            } else {
                toast.current.show({ severity: 'error', summary: 'error', detail: message, life: 3000 });
                setgetLoading(false);
            }
        } catch (error) {
            console.log('error', error);
            setgetLoading(false);
        }
    };

    useEffect(() => {
        const delayDebounce = setTimeout(() => {
            if (keyword) {
                GetList();
            }
        }, 500);
        return () => clearTimeout(delayDebounce);
    }, [keyword]);

    const handleDeleteProduct = async (product_id) => {
        try {
            setgetLoading(true);
            const response = await axios.delete(`${apiUrl}/Masters/DeleteProduct`, { params: { product_id }, headers });
            const { success, data, message } = response.data;
            if (success) {
                GetList();
            } else {
                toast.current.show({ severity: 'error', summary: 'error', detail: message, life: 3000 });
            }
        } catch (error) {
            console.log('error', error);
            setgetLoading(false);
        }
    };

    const renderProductShow = (rowData) => {
        return (
            rowData.product_show === 1 ? <Tag icon="pi pi-check" severity="success" value=" Yes"></Tag> : <Tag icon="pi pi-times" severity="danger" value=" No"></Tag>)
    };
    const renderProductOrder = (rowData) => {
        return (
            rowData.product_for_order === 1 ? <Tag icon="pi pi-check" severity="success" value=" Yes"></Tag> : <Tag icon="pi pi-times" severity="info" value=" No"></Tag>)
    };

    const ActionProduct = (rowData) => {
        return (
            <div className="d-flex justify-content-around align-itmes-center">
                <NavLink to={`/Product/${rowData.product_id}`}>
                    <Button
                        size='small'
                        icon="pi pi-pencil"
                        className="p-button-info me-3"
                        onClick={() => confirmDelete(rowData)}
                    />
                </NavLink>
                <Button
                    size='small'
                    icon="pi pi-trash"
                    className="p-button-danger me-2"
                    onClick={() => confirmDelete(rowData)}
                />
                <Button
                    size='small'
                    icon="pi pi-barcode"
                    className="p-button"
                    disabled={!rowData.product_barcode}
                    onClick={() => generateBarcode(rowData.product_barcode)}
                />
            </div>
        );
    };

    const confirmDelete = (rowData) => {
        setSelectedProduct(rowData);  // Store the product to be deleted
        setShowConfirmDialog(true);    // Show confirmation dialog
    };

    const deleteConfirmed = () => {
        if (selectedProduct) {
            handleDeleteProduct(selectedProduct.product_id);  // Call the function to delete the product
        }
        setShowConfirmDialog(false);  // Close the dialog
    };

    const cancelDelete = () => {
        setShowConfirmDialog(false);  // Close the dialog if cancelled
    };

    useEffect(() => {
        GetList();
    }, [store_id]);

    return (
        <>
            <div className="container-fluid">
                <Toast ref={toast} />
                <div className="d-flex justify-content-between align-items-center my-4">
                    <div className="main-heading">
                        <h6>Product List</h6>
                    </div>
                    <div className="main-heading-right">
                        <h6>Masters/Product List</h6>
                    </div>
                </div>
                <div className="bg-dark text-white p-3 rounded-top d-flex flex-wrap justify-content-between align-items-center">
                    <h4>Product List</h4>
                    <NavLink to={'/Product'}><Button icon="pi pi-plus-circle" rounded={true} severity="secondary" /></NavLink>
                </div>
                <div className="card-header p-3">
                    <div className="row">
                        <div className="col-md-4">
                            <label className="form-label">Search</label>
                            <input
                                type="text"
                                value={keyword}
                                className="form-control"
                                onChange={(e) => setKeyword(e.target.value)}
                                required={true}
                                placeholder='Enter Product Or Category Name'
                            />
                        </div>
                    </div>
                </div>
                <DataTable
                    value={rows}
                    paginator
                    rows={10}
                    loading={getLoadingrows}
                    responsiveLayout="scroll"
                    emptyMessage="No products found"
                >
                    <Column field="store_name" header="Store" />
                    <Column field="category_name" header="Category" />
                    <Column field="product_name" header="Product"
                        body={(rowData) => (
                            <div className="d-flex align-items-center">
                                <img
                                    src={rowData.product_image_url}
                                    alt={rowData.product_name}
                                    style={{ width: 40, height: 40, marginRight: '10px' }}
                                />
                                {rowData.product_name}
                            </div>
                        )}
                    />
                    <Column field="product_barcode" header="Barcode" />
                    <Column field="product_purchase_rate" header="Purchase Rate" />
                    <Column field="product_retail_rate" header="Retail Rate" />
                    <Column field="product_sale_rate" header="Sale Rate" />
                    <Column field="product_show" header="Show" body={renderProductShow} />
                    <Column field="product_for_order" header="Order" body={renderProductOrder} />
                    <Column field="product_min_alert" header="Alert" />
                    <Column header="Action" body={ActionProduct} />
                </DataTable>
                <Dialog
                    visible={showConfirmDialog}
                    style={{ width: '450px' }}
                    header="Confirm Deletion"
                    modal
                    footer={
                        <div className='d-flex justify-content-around align-items-center'>
                            <Button label="No" outlined icon="pi pi-times" onClick={cancelDelete} />
                            <Button label="Yes" icon="pi pi-check" onClick={deleteConfirmed} />
                        </div>
                    }
                    onHide={cancelDelete}
                >
                    <p>Are you sure you want to hide this product?</p>
                </Dialog>
            </div>
        </>
    );
};

export default ProductList;
